var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-custom" },
    [
      _c(
        "a-tooltip",
        [
          _vm.tips
            ? _c("template", { slot: "title" }, [_vm._v(_vm._s(_vm.tips))])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "image-box",
              style: { width: _vm.width + "px", height: _vm.height + "px" },
              on: { click: _vm.handleSelectImage },
            },
            [
              _vm.imgUrl
                ? _c("img", { attrs: { src: _vm.imgUrl, alt: "" } })
                : _c("div", { staticClass: "empty-mask" }, [
                    _vm._v("选择图片"),
                  ]),
              _vm._v(" "),
              _c("div", { staticClass: "update-box-black" }),
              _vm._v(" "),
              _c("div", { staticClass: "uodate-repalce" }, [
                _vm._v(_vm._s(_vm.imgUrl ? "替换" : "选择")),
              ]),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }